// extracted by mini-css-extract-plugin
export var actions = "_rr-4";
export var item = "_rr-1";
export var price = "_rr-3";
export var quantity = "_rr-2";
export var table = "_rr-0";